import type { ContentPublication } from '../types';

/**
 * What an approved ads change task says about Google Ads: applying, applied (with what was set), not applied because
 * the live setting or the data moved on (drafted again, so no retry), or failed (retry when the owner asks).
 */
export type AdsChangeStatus =
  | { kind: 'applying'; text: string }
  | { kind: 'applied'; text: string }
  | { kind: 'not_applied'; text: string }
  | { kind: 'failed'; text: string };

export function adsChangeStatus(publication: ContentPublication | undefined): AdsChangeStatus {
  if (!publication)
    return { kind: 'applying', text: 'Approved. Applying the change in Google Ads…' };
  if (publication.status === 'published')
    return {
      kind: 'applied',
      text: `Made in Google Ads through PracticeNova: ${publication.summary ?? 'the approved change'}.`,
    };
  if (publication.conflict)
    return {
      kind: 'not_applied',
      text: `Not applied: ${publication.failureReason ?? 'Google Ads no longer matches what you approved.'} Jenny will draft it again.`,
    };
  return {
    kind: 'failed',
    text: `Not applied: ${publication.failureReason ?? 'Google Ads did not take the change.'}`,
  };
}

/** The undo's result, in one line. */
export function undoOutcomeWords(outcome: { status: string; reason: string | null }): string {
  if (outcome.status === 'applied') return 'Undone in Google Ads: the earlier values are back.';
  return `Not undone: ${outcome.reason ?? 'Google Ads did not take the change.'}`;
}

/** A draft written before changes were applied: it told the owner to make the change in Google Ads themselves. */
export function adsChangeMadeByHand(change: string | undefined): boolean {
  return /make the change in (?:Google Ads|the ad account) yourself/i.test(change ?? '');
}
